// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"793b0900","879":"43fab7a2"}[chunkId] + ".chunk.js");